import { defaultLocale } from "../../components/Translation";

const rules = [
  {
    country: "US",
    default: "en",
    exceptions: [],
  },
  {
    country: "CA",
    default: "en",
    exceptions: [
      {
        state_region: "QC",
        language: "fr",
      },
    ],
  },
  {
    country: "MX",
    default: "es",
    exceptions: [],
  },
];

export function getLanguageFromLocation(address) {
  const country = rules.find(
    (country) => country.country.toLowerCase() === address.country.toLowerCase(),
  );
  if (!country) return defaultLocale;

  return (
    country?.exceptions.find(
      (exception) => exception.state_region.toLowerCase() === address.state_region.toLowerCase(),
    )?.language || country.default
  );
}
